require('./brokerOutstandingValuesView.scss');

const React = require('react');
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

const BrokerSearch = require('components/broker/brokerSearch/brokerSearch');
const BrokerSearchAction = require('actions/brokerSearch');
const BrokerAd = require('components/commons/broker/ads/brokerAd');

const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

class BrokerOutstandingValuesView extends React.Component {
    render() {
        const breadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerMarkets'),
                url: '/myprofile/broker/markets'
            },
            {
                text: formatText('breadcrumb-brokerOutstandingValues'),
                url: ''
            }
        ];

        return (
            <div className="broker-outstanding-values-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        finalTitle={getFinalTitle('breadcrumb-brokerOutstandingValues')}
                    />
                </OKCover>
                <section className="broker-outstanding-values-view__body">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-8">
                            <iframe
                                frameBorder="0"
                                width="100%"
                                height=""
                                scrolling="no"
                                src=""
                            />
                        </div>
                        <div className="col-xs-4">
                            <div className="broker-outstanding-values-view__searchbox">
                                <BrokerSearch
                                    onHandleSearch={this.props.handleSearchProduct}
                                    onHandleSearchReset={this.props.handleSearchReset}
                                    searchState={this.props.searchProducts}
                                />
                            </div>
                            <BrokerAd
                                myName="Deposito combinado DUO" //@hardcoded
                                introText="La tranquilidad de un depósito bancario y las ventajas de un fondo de inversión." //@hardcoded
                                backgroundUrl="http://res.cloudinary.com/repunck/image/upload/v1469815564/inlovecouple_fx1kxx.jpg" //@hardcoded
                            />
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

BrokerOutstandingValuesView.propTypes = {
    handleSearchProduct: PropTypes.func,
    handleSearchReset: PropTypes.func,
    searchProducts: PropTypes.object,
}

module.exports.constructor = BrokerOutstandingValuesView;
module.exports.BrokerOutstandingValuesView = connect(
    state => ({
        searchProducts: state.brokerSearch,
    }), {
        handleSearchProduct: BrokerSearchAction.searchProduct,
        handleSearchReset: BrokerSearchAction.clearResults
    })(BrokerOutstandingValuesView);
